var render = function render(){
  var _vm$currentDownloadSt, _vm$currentDownloadSt2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', [_c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": _vm.templateTitle
    }
  }), _c('div', {
    staticClass: "d-flex justify-content-center mt-3",
    staticStyle: {
      "min-width": "430px"
    }
  }, [_c('div', {
    staticClass: "w-100 d-flex flex-column flex-lg-row flex-xl-row align-items-center justify-content-lg-between justify-content-xl-between"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'client-templates'
      }
    }
  }, [_c('v-btn', {
    staticClass: "mb-4 mb-lg-0 mb-xl-0",
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": _vm.primaryButtonColor
    }
  }, [_vm._v("Back To All Templates")])], 1), _c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": _vm.primaryButtonColor
    },
    on: {
      "click": _vm.downloadHandler
    }
  }, [_vm._v("Download Template")])], 1)])], 1)], 1), _c('section', {
    staticClass: "section p-0 mt-5 mb-5 section-content"
  }, [_c('div', {
    staticClass: "container p-0"
  }, [_c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-lg-4 col-xl-4 col-12 p-0"
  }, [_c('div', {
    staticClass: "template-container"
  }, [_c('div', {
    staticClass: "pdf-container pt-2 px-2"
  }, [_vm.isPdfAvailable ? _c('div', {
    staticClass: "pdf-template"
  }, [_c('embed', {
    staticStyle: {
      "padding-bottom": "'56.25%'"
    },
    attrs: {
      "src": `${_vm.templatePdfUrl}#toolbar=0&navpanes=0&scrollbar=0`,
      "width": "100%",
      "height": "100%"
    }
  })]) : _c('div', {
    staticClass: "pdf-failed"
  }, [_vm._v(" The PDF file for \"" + _vm._s(_vm.templateTitle) + "\" failed to be displayed and is not available. ")])])])]), _c('div', {
    staticClass: "col-lg-8 col-xl-8 col-12 p-0 pb-3 px-3 mt-4 mt-lg-0 mt-xl-0"
  }, [_vm._m(0), _c('div', [_c('p', {
    staticClass: "pdf-template-description-text",
    domProps: {
      "innerHTML": _vm._s(_vm.templateDescription)
    }
  })])])])])]), _c('ModalWidget', {
    attrs: {
      "id": "modal-download-status",
      "title": "Download Document Status",
      "centered": "",
      "hideFooter": "",
      "hideHeaderClose": !_vm.isDownloadCompleted,
      "noCloseOnBackdrop": !_vm.isDownloadCompleted,
      "closeHandler": _vm.closeModal
    }
  }, [_c('p', {
    staticClass: "modal-paragraph text-center px-5",
    style: {
      color: _vm.modalTextColor
    },
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v(" " + _vm._s(_vm.modalStatusStatement) + "   "), ((_vm$currentDownloadSt = _vm.currentDownloadStatus) === null || _vm$currentDownloadSt === void 0 ? void 0 : _vm$currentDownloadSt.status) === 'Success' ? _c('font-awesome-icon', {
    attrs: {
      "size": "lg",
      "icon": ['fas', 'check-circle']
    }
  }) : _vm._e(), ((_vm$currentDownloadSt2 = _vm.currentDownloadStatus) === null || _vm$currentDownloadSt2 === void 0 ? void 0 : _vm$currentDownloadSt2.status) === 'Failed' ? _c('font-awesome-icon', {
    attrs: {
      "size": "lg",
      "icon": ['fas', 'times-circle']
    }
  }) : _vm._e()], 1), _c('b-button', {
    key: "",
    staticClass: "modal-btn",
    attrs: {
      "slot": "row-buttons",
      "id": "input-3",
      "size": "sm",
      "disabled": !_vm.isDownloadCompleted
    },
    on: {
      "click": _vm.closeModal
    },
    slot: "row-buttons"
  }, [_vm._v("OK ")])], 1)], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('p', {
    staticClass: "pdf-description pdf-template-description-title"
  }, [_vm._v("About this template")])]);

}]

export { render, staticRenderFns }